import up from 'react-addons-update';
import {find, startsWith, replace, isArray, reduce} from 'lodash';

// Test if a dom element is child of one of the element in the isChildOf array
export function isElementChildOf(domElement, isChildOfDomElements){
    const potentialParents = isArray(isChildOfDomElements) ? isChildOfDomElements : [ isChildOfDomElements ];
    const parent = find(potentialParents, (parentElem) => {
        return (parentElem && parentElem.contains(domElement));
    });
    return (parent) ? true : false;
}

export const EMPTY_UUID: string = '00000000-0000-0000-0000-000000000000';

// Immutable object updater util.
// obj: The object you want to update/copy
// field: The field you want to update
// The new value
export function upVal(obj, field, val){
    return up(obj, { [field]: { $set: val } });
}

export function concatUrl(base, path) {
    if(base[base.length - 1] == '/' && path[0] == '/') { // If both have a slash
        return base.substr(0, base.length - 1) + path;
    } else if(base[base.length - 1] != '/' && path[0] != '/') // If node have a slash
        return base + '/' + path;
    return base + path;
}

export function buildProductImage(homeUrl, product, isWide) {
    const categoryFilter = "categoryimage://";
    const defaultImageFilter = "homesquareimage://";
    const externalImageFilter = "http";
    
    // isWide va contenir exactement si on support le wide selon la largeur de l'ecran en temps réel
    const imageUrl = (isWide) ? product.homeWideImageUrl : product.homeSquareImageUrl;
    
    const isProductImage = !startsWith(imageUrl, categoryFilter);
    const isExternalImage = startsWith(imageUrl, externalImageFilter);
    let fullUrl;

    if (isProductImage) {
        if (isExternalImage) 
            fullUrl = imageUrl;
        else if (startsWith(imageUrl, defaultImageFilter))
            fullUrl = concatUrl(homeUrl, concatUrl(tsapp.staticContentUrl, replace(imageUrl, defaultImageFilter, "/img/")));
        else 
            fullUrl = concatUrl(tsapp.restBaseUrl, imageUrl);
    } else {
        fullUrl = concatUrl(tsapp.staticContentUrl, replace(imageUrl, categoryFilter, "/img/defaulticon/"));
    }

    return {
        productImageUrl: fullUrl,
        isProductImage: isProductImage
    };
}

export function convertTicksToDate(ticks, moment) {
    // Ticks are in nanotime : we need to convert them to microtime (JS)
    const ticksToMicrotime = ticks / 10000;

    // Ticks are recorded from 1/1/1 : get microtime difference from 1/1/1/ to 1/1/1970
    const epochMicrotimeDiff = Math.abs(new Date(0, 0, 1).setFullYear(1));

    return moment(new Date(ticksToMicrotime - epochMicrotimeDiff));
}


export function toDict<T, K extends string | number | symbol>(list: T[], fieldSelector: (item: T) => K): Record<K, T> {
    return reduce(list, (acc, obj) => {
        acc[fieldSelector(obj)] = obj;
        return acc;
    } , {} as any);
}
